import type { BasicRoleUser } from '~/models/User/BasicUser'
import type { Group, GroupMember } from '~/models/Group'
import { externalClient } from '~/api/client/externalClient'

export default function useGroupsApi() {
  const getGroups = async (): Promise<Group[]> => {
    return (await externalClient.get('/frontend/groups')).data
  }

  const postGroup = async (group: Group): Promise<Group> => {
    return (await externalClient.post('/frontend/groups', group)).data
  }

  const putGroup = async (group: Group): Promise<Group> => {
    return (await externalClient.put(`/frontend/groups/put?groupId=${encodeURIComponent(group.groupId)}`, group)).data
  }

  const deleteGroup = async (groupId: string): Promise<Group> => {
    return (await externalClient.delete(`/frontend/groups/delete?groupId=${encodeURIComponent(groupId)}`)).data
  }

  const getGroupMembers = async (groupId: string): Promise<GroupMember[]> => {
    return externalClient.get(`/frontend/groups/get/members?groupId=${encodeURIComponent(groupId)}`)
      .then(response => response.data.members ?? [])
  }

  const putGroupMembers = async (groupId: string, members: GroupMember[]): Promise<GroupMember[]> => {
    const response = await externalClient.put(`/frontend/groups/put/members?groupId=${encodeURIComponent(groupId)}`, {
      unknownMembers: 0,
      members: [...members]
    })
    return response?.data?.members ?? []
  }

  const searchUsers = async (query: string): Promise<BasicRoleUser[]> => {
    return (await externalClient.get(`/frontend/users?query=${encodeURIComponent(query)}`)).data
  }

  return {
    getGroups,
    putGroup,
    deleteGroup,
    getGroupMembers,
    putGroupMembers,
    searchUsers,
    postGroup,
  }
}
